<script setup lang="ts">
import heroGreen from '@/assets/bulkImport/summary-hero-green.svg'
import heroRed from '@/assets/bulkImport/summary-hero-red.svg'

const props = withDefaults(defineProps<{ accent?: 'green' | 'red' }>(), {
  accent: 'green',
})

const src = props.accent === 'red' ? heroRed : heroGreen
</script>

<template>
  <img :src="src" alt="" />
</template>
